import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyExpense = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/expenses',

        branches: [],
        branchesLoading: false,

        expenseTypes: [],
        expenseTypesLoading: false,
        expenseTypeLoading: false,

        expenseCategories: [],
        expenseCategoriesLoading: false,
        expenseCategoryLoading: false,

        paymentMethods: [],
        paymentMethodsLoading: false,
        paymentMethodLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        branches: state => state.branches,

        expenseTypes: state => state.expenseTypes,

        expenseCategories: state => state.expenseCategories,

        paymentMethods: state => state.paymentMethods,
    },
};
